// Import React components
import { useEffect, useRef, useState } from "react";
import { NavLink, useSearchParams } from "react-router-dom";
import {
  Nav,
  Navbar,
  NavDropdown,
  Dropdown,
  DropdownButton,
  Button,
} from "react-bootstrap";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserCircle,
  faAddressCard,
  faListCheck,
  faCog,
  faAddressBook,
  faMessage,
  faTicket,
  faCogs,
  faList,
  faUser,
  faUserEdit,
  faRightFromBracket,
  faSliders,
  faDashboard,
  faCloud,
  faDesktop,
  faScrewdriverWrench,
  faPersonRunning,
  faArrowRotateForward,
  faSignal,
  faTextHeight,
  faTextWidth,
  faMagnifyingGlassChart,
  faWaveSquare,
  faPerson,
  faPeopleGroup,
} from "@fortawesome/free-solid-svg-icons";

// Import the custom components
import { loginRequest, protectedResources, b2cPolicies } from "../authConfig";
import useFetchWithMsal from "../hooks/useFetchWithMsal";

import companyLogo from "../images/logos/TechGuyDomLogo.svg";

export const NavigationBar = () => {
  const [searchParams] = useSearchParams();
  const { instance, inProgress } = useMsal();
  let activeAccount;

  if (instance) {
    activeAccount = instance.getActiveAccount();
  }

  // MSAL Related Objects
  const { error, execute } = useFetchWithMsal({
    scopes: [
      ...protectedResources.scopes.read,
      ...protectedResources.scopes.write,
    ],
  });

  const handleLoginRedirect = () => {
    instance.loginRedirect(loginRequest).catch((error) => console.log(error));
  };

  const handleLogoutRedirect = () => {
    instance.logoutRedirect();
  };

  const handleProfileEdit = () => {
    if (inProgress === InteractionStatus.None) {
      instance.acquireTokenRedirect(b2cPolicies.authorities.editProfile);
    }
  };

  useEffect(() => {
  }, [execute]);

  return (
    <>
      <Navbar
        collapseOnSelect
        expand="lg"
        variant="light"
        className="navbar-custom"
      >
        <div className="container-fluid navbarContainer">
          <Navbar.Brand href="/">
            <img
              src={companyLogo}
              alt="TGD Logo"
              style={{
                height: "42px",
                margin: "0px 0px 0px 0px",
                padding: "0px 0px 0px 0px",
              }}
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link as={NavLink} to="/about" className="navbarButton">About</Nav.Link>
              <Nav.Link as={NavLink} to="/services" className="navbarButton">Services</Nav.Link>
              <Nav.Link as={NavLink} to="/faq" className="navbarButton">FAQ</Nav.Link>
            </Nav>
            {/* <Nav.Link className="navbarButton" href="https://www.secureserver.net/?pl_id=597614" target="_blank">
              Domain and Web Hosting Services
            </Nav.Link> 
            <Nav.Link className="navbarButton" href="https://techguydom.screenconnect.com" target="_blank">
              Remote Support
            </Nav.Link> 
            <Nav.Link className="navbarButton" href="https://square.link/u/2HNpYE7l" target="_blank">
              Make a Payment
            </Nav.Link>  */}
            {/* <Nav.Link className="navbarButton" href="Interests">
              Interests
            </Nav.Link> */}
            {/* <Nav.Link className="navbarButton" href="Portfolio">
              Portfolio
            </Nav.Link> */}
            {/* <Nav.Link className="navbarButton" href="About">
              About
            </Nav.Link> */}
            <AuthenticatedTemplate>
              {/* <Nav className="me-auto">
                <NavDropdown
                  title={
                    <span>
                      <FontAwesomeIcon icon={faSliders} />
                      &nbsp; Placeholder
                    </span>
                  }
                  id="collasible-nav-dropdown"
                  className="navbarButton"
                >
                  <NavDropdown.Item href={"/System/ClaimsList"}>
                    <FontAwesomeIcon icon={faAddressBook} />
                    &nbsp; Placeholder
                  </NavDropdown.Item>
                </NavDropdown>
              </Nav> */}
              <div className="navbar-collapse justify-content-end">
                <Nav>
                  <NavDropdown
                    title={
                      <span>
                        {activeAccount !== null ? activeAccount.name : ""}
                      </span>
                    }
                    id="collasible-nav-dropdown"
                    className="navbarButton navAlignRight"
                  >
                    <NavDropdown.Item
                      href="https://dommicro.com?loginRedirect=true"
                      className="navBarItemRight"
                    >
                      DOMMICRO.com
                    </NavDropdown.Item>
                    <NavDropdown.Item
                      href="https://10baseg.com?loginRedirect=true"
                      className="navBarItemRight"
                    >
                      10BaseG.com
                    </NavDropdown.Item>
                    <NavDropdown.Divider className="navBarHr" />
                    <NavDropdown.Item
                      href="/System/ClaimsList"
                      className="navBarItemRight"
                    >
                      Claims List
                    </NavDropdown.Item>
                    {/* <NavDropdown.Item
                      href="#"
                      onClick={handleProfileEdit}
                      className="navBarItemRight"
                    >
                      Edit Profile
                    </NavDropdown.Item> */}
                    <NavDropdown.Divider className="navBarHr" />
                    <NavDropdown.Item
                      href="#"
                      onClick={handleLogoutRedirect}
                      className="navBarItemRight"
                    >
                      Sign out
                    </NavDropdown.Item>
                  </NavDropdown>
                </Nav>
              </div>
            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
              <div className="navbar-collapse justify-content-end">
                <Nav.Link
                  className="navbarButton"
                  href="#"
                  onClick={() => handleLoginRedirect()}
                >
                  Sign in
                </Nav.Link>
              </div>
            </UnauthenticatedTemplate>
          </Navbar.Collapse>
        </div>
      </Navbar>
    </>
  );
};
